export default __webpack_public_path__ + "static/media/ic_test_40.e7585cfe.svg";